import { Component, Input, OnInit } from "@angular/core";
import { EMPTY, Observable } from "rxjs";
import { ModalService } from "@core-services/modal.service";
import { Contact, ContactField, ValidationError } from "@models";
import { MultichainContactFacade } from "@modules/main/components/multichain-contact/services/multichain-contact.facade";
import { BpSelectOption } from "@modules/core/components/bp-select/bp-select.component";
import { ContactAddSuccessComponent } from "@modules/main/components/contact/contact-add-success/contact-add-success.component";
import { Helper } from "@helpers/functions";
import { ContactService } from "@main-services/contact.service";
import { InvitationService } from "@main-services/invitation.service";
import { ConfirmModalService } from "@core-services/confirm-modal.service";

@Component({
	selector: "multichain-contact-form",
	templateUrl: "./multichain-contact-form.component.html",
	styleUrls: ["./multichain-contact-form.component.scss"],
	providers: [MultichainContactFacade],
	standalone: false
})
export class MultichainContactFormComponent implements OnInit {
	@Input() newContact: boolean = true;
	@Input() contact: Contact = new Contact();
	public coinOptions$: Observable<BpSelectOption[]> = EMPTY;
	public networkOptions$: Observable<BpSelectOption[]> = EMPTY;
	public inviteButtonText = "invite_now_contact";

	constructor(
		private readonly modalService: ModalService,
		private readonly multichainContactFacade: MultichainContactFacade,
		private readonly contactService: ContactService,
		private readonly invitationService: InvitationService,
		private readonly confirmModalService: ConfirmModalService
	) {}

	ngOnInit(): void {
		this.coinOptions$ = this.multichainContactFacade.getCoinsForDropDown();
		this.networkOptions$ = this.multichainContactFacade.getNetworksForSelectedCoin("1");
	}

	public onCancelButtonClick(): void {
		this.modalService.popAll();
	}

	public save(): void {
		this.contact.setFields(
			this.contact
				.getFields()
				.filter((f) => !!f.getValue())
				.map((f) => {
					if (!f.getDestinationTag() || f.getDestinationTag().trim() === "") {
						f.setDestinationTag("");
					}
					return f;
				})
		);

		this.contactService.upsertCall(this.contact).subscribe({
			next: () => {
				if (this.contact.getId()) {
					this.modalService.popAll();
				} else {
					this.modalService.showModal(ContactAddSuccessComponent, this.contact, { backdropDismiss: false });
				}
			},
			error: (error) => {
				if (error instanceof ValidationError && error?.responseErrors) {
					Helper.infoService.setError(error);
				} else {
					Helper.handleError(error, this.contact);
				}

				// For missing address show an error toast - inline error is not possible
				if (error instanceof ValidationError && error.metaContains("fields")) {
					Helper.infoService.setError(error);
				}
			}
		});
	}

	public addNewAddress(): void {
		let field = new ContactField();
		this.contact.addField(field);
	}

	public deleteField(field: ContactField): void {
		this.contact.setFields(this.contact.getFields(false, true).filter((f) => field !== f));
	}

	public startButtonTimer(): void {
		this.inviteButtonText = "sending_invite_contacts";
		let time: number = 3;
		const timer = window.setInterval(() => {
			if (--time <= 0) {
				clearInterval(timer);
				if (!this.contact.hasError("email")) {
					this.inviteButtonText = "invite_more_contacts";
				}
			}
		}, 1000);
	}

	public sendInvite(): void {
		this.invitationService.taf.email = this.contact.getEmail();
		this.invitationService.tellAFriend().subscribe(
			() => this.startButtonTimer(),
			(e) => Helper.handleError(e, this.contact)
		);
	}

	public delete(): void {
		this.confirmModalService
			.showConfirmModal(
				"really_delete_contact_title",
				"really_delete_contact",
				"really_delete_contact_button_delete_now",
				"cancel"
			)
			.subscribe((yes) => {
				if (yes) {
					this.contactService.deleteContact(this.contact);
					this.modalService.popAll();
				}
			});
	}
}
